import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { RouterModule } from '@angular/router';

// import { SocialLoginModule, AuthServiceConfig, LoginOpt } from 'angularx-social-login';
import { GoogleLoginProvider, FacebookLoginProvider } from 'angularx-social-login';

import { CarouselModule } from 'ngx-owl-carousel-o';

import { ImageCropperModule } from 'ngx-image-cropper';

import { StarRatingModule, StarRatingConfigService } from 'angular-star-rating';

import { CustomStarsService } from '../services/custom-stars.service';

import { ColorPickerModule } from 'ngx-color-picker';

import { ToastrModule } from 'ngx-toastr';

import { MatSelectModule } from '@angular/material/select';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatDialogModule } from '@angular/material/dialog';
import { MatInputModule } from '@angular/material/input';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatIconModule } from '@angular/material/icon';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatSliderModule } from '@angular/material/slider';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatMenuModule } from '@angular/material/menu';
import { MatRadioModule } from '@angular/material/radio';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDividerModule } from '@angular/material/divider';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { MatChipsModule } from '@angular/material/chips';
import { ClickOutsideModule } from 'ng-click-outside';

// const fbLoginOptions: LoginOpt = {
//     scope: 'email',
//     return_scopes: true,
//     enable_profile_selector: true
// };

// const config = new AuthServiceConfig([
//     {
//         id: GoogleLoginProvider.PROVIDER_ID,
//         provider: new GoogleLoginProvider('513395809723-70me9h0dmofcf8bk5oiibrt50fdef59p.apps.googleusercontent.com')
//     },
//     {
//         id: FacebookLoginProvider.PROVIDER_ID,
//         provider: new FacebookLoginProvider('335931163095578', fbLoginOptions)
//     }
// ]);

// export function provideConfig() {
//     return config;
// }


@NgModule({
    declarations: [

    ],

    imports: [
        CommonModule,
        RouterModule,
        // SocialLoginModule,
        CarouselModule,
        ImageCropperModule,
        StarRatingModule.forRoot(),
        ColorPickerModule,
        ToastrModule.forRoot({ timeOut: 800 }),
        MatSelectModule,
        ImageCropperModule,
        MatInputModule,
        MatProgressBarModule,
        ImageCropperModule,
        MatDialogModule,
        ImageCropperModule,
        MatProgressSpinnerModule,
        MatAutocompleteModule,
        MatIconModule,
        MatSidenavModule,
        MatSliderModule,
        MatToolbarModule,
        MatCheckboxModule,
        MatDividerModule,
        MatSlideToggleModule,
        MatMenuModule,
        MatRadioModule,
        MatDatepickerModule,
        MatNativeDateModule,
        DragDropModule,
        ClickOutsideModule,
        MatChipsModule,
    ],

    exports: [
        // SocialLoginModule,
        CarouselModule,
        ImageCropperModule,
        StarRatingModule,
        ColorPickerModule,
        ToastrModule,
        MatSelectModule,
        MatInputModule,
        MatProgressBarModule,
        MatDialogModule,
        MatProgressSpinnerModule,
        MatAutocompleteModule,
        MatIconModule,
        MatSidenavModule,
        MatSliderModule,
        MatToolbarModule,
        MatCheckboxModule,
        MatDividerModule,
        MatSlideToggleModule,
        MatMenuModule,
        MatRadioModule,
        MatDatepickerModule,
        MatNativeDateModule,
        DragDropModule,
        ClickOutsideModule,
        MatChipsModule,
    ],

    providers: [
        // {
        //     provide: AuthServiceConfig,
        //     useFactory: provideConfig
        // },
        {
            provide: StarRatingConfigService,
            useClass: CustomStarsService
        }
    ]
})

export class Shared2Module { }
